export var variants = {
    ROUND: "round",
    FLAT: "flat"
};
export var scales = {
    MD: "md",
    SM: "sm"
};
